import { render, staticRenderFns } from "./SettingsAttendees.vue?vue&type=template&id=76af638d&"
import script from "./SettingsAttendees.vue?vue&type=script&lang=js&"
export * from "./SettingsAttendees.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAttendees.vue?vue&type=style&index=0&id=76af638d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports